import { render } from "./B2bPageOrdersReceived.vue?vue&type=template&id=36d67a33&scoped=true&lang=pug"
import script from "./B2bPageOrdersReceived.vue?vue&type=script&lang=js"
export * from "./B2bPageOrdersReceived.vue?vue&type=script&lang=js"

import "./B2bPageOrdersReceived.vue?vue&type=style&index=0&id=36d67a33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d67a33"]])

export default __exports__